module.exports = __webpack_public_path__ + "static/img/noto-sans.65e2a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noto-sans.png
// module id = pGk7
// module chunks = 0